import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from "@mui/material/node";

export const ResetLayoutButton = (props) => {
    return (
        <IconButton aria-label="Refresh layout" onClick={props.action} color="inherit" sx={{ m: 0.5 }}>
            <RefreshIcon />
        </IconButton>
    );
}
